export const EventsSummaryConfig = {
    name            : 'Events summary',
    icon            : 'i5-events-summary',
    image           : 'events-summary',
    iconSvg         : 'isvg-view-events-summary',
    url             : 'events-summary',
    description     : 'Current, previous, and next week’s events and milestones.',
    canBeInProject  : true,
}

export const CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG = {
    ...EventsSummaryConfig,
    // key2: "newValue2",  // Replacing the value for key2
}